import i18n from 'utils/i18n'
import type { MyWinesFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  SWITCHER,
  SCORE,
  INTERVAL,
  MULTISELECT_SWITCHER,
  myWinesFiltersTitle,
  myWinesFiltersName,
  myWinesFiltersKey,
} from 'utils/consts'

export const getMyWinesFiltersCollection = () => [
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(myWinesFiltersTitle.offerTypeFilter),
    filterName: myWinesFiltersName.offerTypeFilter,
    apiFilterName: myWinesFiltersKey.offerTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.brandFilter),
    filterName: myWinesFiltersName.brandFilter,
    apiFilterName: myWinesFiltersKey.brandFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.wineTypeFilter),
    filterName: myWinesFiltersName.wineTypeFilter,
    apiFilterName: myWinesFiltersKey.wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.wineColourFilter),
    filterName: myWinesFiltersName.wineColourFilter,
    apiFilterName: myWinesFiltersKey.wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.sweetnessTypeFilter),
    filterName: myWinesFiltersName.sweetnessTypeFilter,
    apiFilterName: myWinesFiltersKey.sweetnessTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.vintageFilter),
    filterName: myWinesFiltersName.vintageFilter,
    apiFilterName: myWinesFiltersKey.vintageFilter,
  },
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(myWinesFiltersTitle.showLatestVintagesFilter),
    filterName: myWinesFiltersName.showLatestVintagesFilter,
    apiFilterName: myWinesFiltersKey.showLatestVintagesFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.nationalGITypeFilter),
    filterName: myWinesFiltersName.nationalGITypeFilter,
    apiFilterName: myWinesFiltersKey.nationalGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.geoIndicationFilter),
    filterName: myWinesFiltersName.geoIndicationFilter,
    apiFilterName: myWinesFiltersKey.geoIndicationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.specialClassificationFilter),
    filterName: myWinesFiltersName.specialClassificationFilter,
    apiFilterName: myWinesFiltersKey.specialClassificationFilter,
  },
  {
    type: filterTypes[MULTISELECT_SWITCHER],
    title: i18n.t(myWinesFiltersTitle.grapesFilter),
    filterName: myWinesFiltersName.grapesFilter,
    apiFilterName: myWinesFiltersKey.grapesFilter,
    switchType: filterTypes[SWITCHER],
    switchFilterName: myWinesFiltersName.monocepageFilter,
    switchTitle: i18n.t(myWinesFiltersTitle.monocepageFilter),
    switchApiFilterName: myWinesFiltersKey.monocepageFilter,
  },
  {
    type: filterTypes[INTERVAL],
    title: i18n.t(myWinesFiltersTitle.alcoholLevelFilter),
    filterName: myWinesFiltersName.alcoholLevelFilter,
    apiFilterName: myWinesFiltersKey.alcoholLevelFilter,
    defaultIntervalKey: 'alcoholLevels',
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.certificationFilter),
    filterName: myWinesFiltersName.certificationFilter,
    apiFilterName: myWinesFiltersKey.certificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.bottleSizeFilter),
    filterName: myWinesFiltersName.bottleSizeFilter,
    apiFilterName: myWinesFiltersKey.bottleSizeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(myWinesFiltersTitle.packageTypeFilter),
    filterName: myWinesFiltersName.packageTypeFilter,
    apiFilterName: myWinesFiltersKey.packageTypeFilter,
  },
  {
    type: filterTypes[SCORE],
    title: i18n.t(myWinesFiltersTitle.wwlRatingFilter),
    filterName: myWinesFiltersName.wwlRatingFilter,
    apiFilterName: myWinesFiltersKey.wwlRatingFilter,
  },
]

export const myWinesFiltersConfig: MyWinesFiltersConfig = {
  component: 'myWines',
  getFiltersCollection: getMyWinesFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
